import { Query, gql } from 'apollo-angular';


import { Injectable } from '@angular/core';
import { PackageFragment, PackageProduct } from './package-product.fragment';

@Injectable({
  providedIn: 'root'
})
export class GetReplaceableProductGQL extends Query<GetReplaceableProductGQLResponse, GetReplaceableProductGQLVariables> {
  document = gql`
    query getReplaceableProduct($productId: ID!, $storefrontId: ID) {
      product(productId: $productId) {
        ...Package
      }
      storefronts(storefrontIds: [$storefrontId]) {
        subscriptionsSummary(productId: $productId) {
          activeCount
        }
      }
    }
    ${PackageFragment}
  `;
}

interface GetReplaceableProductGQLVariables {
  productId: string;
  storefrontId: string;
}

interface GetReplaceableProductGQLResponse {
  product: PackageProduct;
  storefronts: StorefrontSubscriptionSummary;
}

export interface ReplacableProductResponse {
  product: PackageProduct;
  activeSubscriptionCount: number;
}

export interface StorefrontSubscriptionSummary {
  subscriptionsSummary: SubscriptionsSummary;
}

export interface SubscriptionsSummary {
  activeCount: number;
}
